import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compra',
  templateUrl: './compra.component.html',
  styleUrls: ['./compra.component.scss']
})
export class CompraComponent implements OnInit {

  constructor(private http: HttpClient) { }

  serviceType: any = 'limpeza';
  ambiente: any = 'residencia';
  tipoAmbiente: any = 'casa';
  tipoLimpeza: any = 'rotina';
  planoRoupa: any = 1;

  ngOnInit() {
    this.http.post('http://localhost:8080/getCleanerById', {
      id: 'fabio@faxinadahora.com'
    }).subscribe(dado => console.log(dado));
  }

  mudaTipoLimpeza(tipo) {
    this.tipoLimpeza = tipo;
  }

  mudaAmbiente(tipo) {
    this.ambiente = tipo;
  }

  mudaTipoAmbiente(tipo) {
    this.tipoAmbiente = tipo;
  }

  mudaTipo(tipo) {
    this.serviceType = tipo;
  }

  mudaPlanoRoupa(tipo) {
    this.planoRoupa = tipo;
  }
}
